import Button from "components/Button";
import moment from "moment";
import React, { useState } from "react";
import {
  MdCheckCircleOutline,
  MdKeyboardArrowDown,
  MdRemoveRedEye,
} from "react-icons/md";
import ModalShowMore from "./modal-show-more";
import ModalDetailTransaction from "./modal-detail-transaction";
import ModalDetailCheckin from "./modal-detail-checkin";
import { useNavigate } from "react-router-dom";

const AccordionTransaction = (props) => {
  const { showMoreBtn = true, data, parentData } = props;
  const [accordion, setAccordion] = useState({ 1: false });
  const [showMore, setShowMore] = useState({ show: false, data: [] });
  const [transaction, setTransaction] = useState({ show: false, data: null });
  const [checkin, setCheckin] = useState({ show: false, data: null });
  const show = data?.length > 3;

  const navigate = useNavigate();

  const showContent = () => {
    switch (parentData?.activity_type) {
      case 3:
        return (
          <div className="flex gap-4">
            <div>
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">
                    Gudang Asal{" "}
                  </span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {data?.source_gudang_name}
              </div>
            </div>
            <div>
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">
                    Gudang Tujuan{" "}
                  </span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {data?.destination_gudang_name}
              </div>
            </div>
          </div>
        );

      case 4:
        return (
          <div className="flex gap-4">
            <div>
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">Nama Sales</span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {parentData?.activity_details?.sales_name}
              </div>
            </div>
          </div>
        );

      case 1:
        return (
          <div className="flex gap-4">
            <div>
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">
                    Nama Supplier
                  </span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {parentData?.activity_details?.supplier_name}
              </div>
            </div>
          </div>
        );

      case 5:
        return (
          <div className="flex gap-4">
            <div>
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">Nama Sales</span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {parentData?.activity_details?.sales_name}
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };
  return (
    <>
      <div
        role="button"
        onClick={() => {
          setAccordion((prev) => ({ ...prev, 1: !prev["1"] }));
        }}
        className="flex w-fit cursor-pointer items-center"
      >
        <h3 className="font-bold">Detail Aktivitas</h3>
        <MdKeyboardArrowDown
          fontSize={20}
          className={
            accordion["1"] ? "rotate-180 transform transition-all" : ""
          }
        />
      </div>

      <div
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          accordion[1] ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="relative">
          {/* <div className="absolute left-[9px] top-[50px] h-[calc(100%-100px)] w-[2px] bg-gray-200"></div> */}

          <div className="flex items-center gap-4 py-3">
            <div className="w-full rounded-xl border-[1px] border-[#e0e0e0] p-4 hover:bg-[#fafafa]">
              <div className="flex items-center justify-between">
                <div className="flex flex-col gap-4">
                  <div className="flex gap-4">
                    <div>
                      <div className="flex flex-col items-start leading-none">
                        <div className="flex items-center gap-2">
                          <span className="min-w-[120px] font-medium">
                            Nama Produk
                          </span>
                        </div>
                      </div>
                      <div className="mt-0.5 text-sm text-gray-600">
                        {parentData?.product?.product_name}
                      </div>
                    </div>
                    <div>
                      <div className="flex flex-col items-start leading-none">
                        <div className="flex items-center gap-2">
                          <span className="min-w-[120px] font-medium">
                            Perubahan Stok
                          </span>
                        </div>
                      </div>
                      <div className="mt-0.5 text-sm text-gray-600">
                        <b>
                          {parentData.addition_types}
                          {parentData?.qty}
                        </b>
                      </div>
                    </div>
                  </div>

                  {showContent()}

                  <div className="flex gap-4">
                    <div>
                      <div className="flex flex-col items-start leading-none">
                        <div className="flex items-center gap-2">
                          <span className="min-w-[120px] font-medium">
                            Stok Awal
                          </span>
                        </div>
                      </div>
                      <div className="mt-0.5 text-sm text-gray-600">
                        {parentData?.stock_before}
                      </div>
                    </div>
                    <div>
                      <div className="flex flex-col items-start leading-none">
                        <div className="flex items-center gap-2">
                          <span className="min-w-[120px] font-medium">
                            Stok Akhir
                          </span>
                        </div>
                      </div>
                      <div className="mt-0.5 text-sm text-gray-600">
                        {parentData?.stock_after}
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => {
                    const url = [
                      `/admin/inventori/purchase-order?s=${parentData?.activity_details?.no_po}`,
                      `/admin/inventori/stok-opname?s=${parentData?.activity_details?.no_so}`,
                      `/admin/inventori/transfer-stok-gudang?s=${parentData?.activity_details?.no_ts}`,
                    ];

                    navigate(
                      url?.[parentData?.activity_type - 1] ?? "/admin/dashboard"
                    );
                  }}
                  className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#BEDBFE] text-[#3A65FF]"
                >
                  <MdRemoveRedEye />
                </button>
              </div>
            </div>
          </div>
        </div>
        {show && showMoreBtn && (
          <Button
            label="Lihat Selengkapnya"
            onClickHandler={() => setShowMore(() => ({ show: true, data }))}
            size="xs"
            variant="DEFAULT"
          />
        )}
        <ModalShowMore
          open={showMore.show}
          onClose={() => setShowMore({ show: false, data: [] })}
          data={showMore.data}
        />
        <ModalDetailTransaction
          open={transaction.show}
          onClose={() => setTransaction({ show: false, data: null })}
          detailData={transaction.data}
        />
        <ModalDetailCheckin
          open={checkin.show}
          onClose={() => setCheckin({ show: false, data: null })}
          detailData={checkin.data}
        />
      </div>
    </>
  );
};

export default AccordionTransaction;
